import { Component, OnInit, ViewChild,ViewEncapsulation,TemplateRef } from '@angular/core';
import { FormArray,FormGroup,FormControl, Validators } from '@angular/forms';
import { ModalDirective, BsModalRef,BsModalService } from 'ngx-bootstrap/modal';
import { LoadService } from '../../services/load.service';
import { LotesService } from '../../services/lotes.service';
import { SpeciesService } from '../../services/species.service';
import { ProveedoresService } from '../../services/providers.service';
import { Lotes } from '../../model/Lotes';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { listLocales } from 'ngx-bootstrap/chronos';
import { FilterUrlService } from '../../services/filter-url.service';
/*import { CreateNewAutocompleteGroup, SelectedAutocompleteItem, NgAutocompleteComponent } from "ng-auto-complete";*/

@Component({
  selector: 'lotes',
  templateUrl: './lotes.component.html',
  styleUrls: ['./lotes.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class LotesComponent implements OnInit {
  @ViewChild(ModalDirective) public lgModal: ModalDirective;
  //@ViewChild(NgAutocompleteComponent) public completer: NgAutocompleteComponent;
  public load:number;
  public primeracarga:boolean;
  public isopen:boolean;
  public alert:string;
  public data_list:any;
  public links: any;
  public meta: any;
  public title:string;
  public isNew:boolean;
  public signupForm:FormGroup;
  public item_to_update:number;
  public especies:any[];
  public proveedores:any[];
  public urlfilter:string;
  public ismousewheel:boolean;
  public ismeridian:boolean;
  public showspinners:boolean;
  public urlconditions:string;
  public modalRef:BsModalRef;
  public lote_eliminar:any;
  public settings = {
    columns:{
      specie: {header: "Especie", type:"text", tipo:"specie",path:"relationships.specie.data.attributes.name",ignored:true },
      company_id: {
        header: "Proveedor",
        type:"obj",
        tipo:"provider",
        path:"relationships.provider.data.attributes.name",
        filter: { visible:true,  id_type:'number', default:'asc', type:'dd' },
      },
      extraction_date: {header: "Fecha Extracción", type:"date" ,filter: { visible:true }},
      reception_date: {header: "Fecha Recepción", type:"date" ,filter: { visible:true }},
      proccess_date: {header: "Fecha Proceso", type:"date",filter: { visible:true } },
      code:{header:"Codigo",type:"text",filter: { visible:true } },
      headquarter: {header: "Centro", type:"text",filter: { visible:true } },
      guide: {header: "Guia", type:"text",filter: { visible:true } },
      ret: {header: "RET", type:"text",filter: { visible:true } }

    },
    actions:{
      edit: true,
      view: false,
      delete: false
    }
  };

  constructor(private _localeService: BsLocaleService,
    private _proveedoresService:ProveedoresService,
    private _especiesService:SpeciesService,
    private _lotesService:LotesService,
    private _loaddata: LoadService,
    private _filter: FilterUrlService,
    private modalService:BsModalService) {
    this.isopen = false;
    this.alert = "";
    this.primeracarga = false;
    this.especies = [];
    this.proveedores = [];
    this.urlfilter = "";
    this.ismousewheel = true;
    this.ismeridian = false;
    this.showspinners = false;
    this.urlconditions = '&sort=-code';
    this.lote_eliminar = null;
  }

  ngOnInit() {
    this._loaddata.loadChange(15);
    this._localeService.use('es');
    this._filter.filterFirstLoad(this.settings);
    this._loaddata.loadCurrent.subscribe(a=> this.load = a);
    this.signupForm = new FormGroup({
      'id': new FormControl("-1",Validators.required),
      'especie': new FormControl("1",Validators.required),
      'proveedor': new FormControl("1",Validators.required),
      'codigo': new FormControl(null,Validators.required),
      'fechaextracion': new FormControl(null,),
      'fecharecepcion': new FormControl(null,),
      'fechaproceso': new FormControl(null,),
      'horaextracion': new FormControl(null,),
      'horarecepcion': new FormControl(null,),
      'horaproceso': new FormControl(null,),
      'centro': new FormControl(''),
      'guia': new FormControl(''),
      'ret': new FormControl('')
    });
    this.loadSpecies();
  }

  /**
  * carga el listado de especies
  */
  loadSpecies():void{
    this.alert = 'Cargando especies.';
    this.isopen = true;
    this._loaddata.loadChange(15);

    this._especiesService.get().subscribe((response:any) => {
      this.especies = response.data;
      this.loadProviders();
    },
    (error) => {
      this.showError(error.error.error);
    });
  }

  loadDataFiltered(filters){
    this._loaddata.loadChange(60);
    this.alert = 'Cargando información.';
    this.isopen = true;

    this._lotesService.getDataFiltered(filters).subscribe(
      (response:any) => {
        this.cleanForm();
        this.data_list = response.data;
        this.links = response.links;
        this.meta = response.meta;
        this._loaddata.loadChange(100);
        if(response.data.length == 0){
          this.alert = "No se encontraron resultados."
        }
        else{
          this.alert = "Carga Correcta.";
        }

        this.isopen =true;
        this.onClosedAutomatic();
        if(this.primeracarga === false){
          this.primeracarga = !this.primeracarga;
        }
      },
      (error) => {
        if(error.status == 0){
          this.alert = 'Busqueda sin resultados.';
          this.onClosedAutomatic();
        }
        else{
          this.showError(error.error.error);
        }
      }
    );
  }

  /**
  * carga el listado de todas las especificaciones
  */
  loadProviders():void{
    this.alert = 'Cargando proveedores.';
    this.isopen = true;
    this._loaddata.loadChange(50);
    this._proveedoresService.get().subscribe((response:any) => {
      this.proveedores = response.data;

      let data = response.data;
      let proveedores:string = "{";
      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          proveedores+='"'+data[key].id+'":"'+data[key].attributes.name+'",';
        }
      }
      proveedores = proveedores.slice(0,-1);
      proveedores+="}";
      this.settings.columns.company_id.filter['data'] = proveedores;

      this.loadData();
    },
    (error) => {
      this.showError(error.error.error);
    });
  }

/**
 * Carga el listado de informacion.
 */
  loadData():void{
    this.alert = 'Cargando lotes.';
    this.isopen = true;
    this._loaddata.loadChange(90);
    this._lotesService.get()
    .subscribe(
      (response:any) => {
        this.cleanForm();
        this.data_list = response.data;
        this.links = response.links;
        this.changeLinks(this.urlconditions);
        this.meta = response.meta;
        this._loaddata.loadChange(100);
        this.alert = "Carga Correcta."
        this.isopen =true;
        this.onClosedAutomatic();
        if(this.primeracarga === false){
          this.primeracarga = !this.primeracarga;
        }
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

/**
 * Envia a la BD los datos del formulario.
 */
  saveForm():void{
    this.alert = "Almacenando lote.";
    this.isopen =true;
    this._loaddata.loadChange(40);
    let prov = this._lotesService.transformData(this.signupForm.value);
    this._lotesService.save(prov).subscribe(
      (response:any) =>{
        this._loaddata.loadChange(60);
        this.hideChildModal();
        this.loadData();
    },
    (error) => {
      //console.log("ERROR: ", error);
      this.showError(error.error.error);
    });
  }

/**
 * Envia a la BD los datos a actualizar.
 */
  updateForm():void{
    this.alert = "Actualizando Lote";
    this.isopen = true;
    this._loaddata.loadChange(35);

    let htmlbody = this._lotesService.transformData(this.signupForm.value);
    let url = this.data_list[this.item_to_update]['links'].self;
    this._lotesService.update(url, htmlbody).subscribe(
      data => {
        this._loaddata.loadChange(70);
        this.alert = "Elemento actualizado.";
        this.hideChildModal();
        this.loadData();
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

/**
 * Elimina la fila seleccionada de la BD
 * @param  data id de la fila a eliminar
 */
  deleteItem(url):void{
    this.alert = "Eliminando lote.";
    this.isopen = true;
    this._loaddata.loadChange(35);
    this._lotesService.delete(url).subscribe(
      (response:any) => {
          this._loaddata.loadChange(70);
          this.alert = "Elemento eliminado.";
          this.lote_eliminar = null;
          this.cerrarModalEliminar();
          this.loadData();
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

/**
 * Carga la información de una fila en el formulario.
 * @param  index Indice de la fila que se carga en el formulario.
 */
  showEditForm(index) {
    this.item_to_update = index;
    let item = this.data_list[index];
    let fechaextracion;
    let fecharecepcion;
    let fechaproceso;
    if(item.attributes.extraction_date === '0000-00-00 00:00:00'){
      fechaextracion = '';
    }
    else{
      fechaextracion = new Date(item.attributes.extraction_date);
    }
    if(item.attributes.reception_date === '0000-00-00 00:00:00'){
      fecharecepcion = '';
    }
    else{
      fecharecepcion = new Date(item.attributes.reception_date);
    }
    if(item.attributes.proccess_date === '0000-00-00 00:00:00'){
      fechaproceso = '';
    }
    else{
      fechaproceso = new Date(item.attributes.proccess_date);
    }
    //console.log("fecha", item.attributes.extraction_date);
    this.signupForm.patchValue({
      'id': item.id,
      'especie': item.attributes.specie_id,
      'proveedor': item.attributes.company_id,
      'codigo': item.attributes.code,
      'fechaextracion': fechaextracion,
      'fecharecepcion': fecharecepcion,
      'fechaproceso': fechaproceso,
      'horaextracion': new Date(item.attributes.extraction_date),
      'horarecepcion': new Date(item.attributes.reception_date),
      'horaproceso': new Date(item.attributes.proccess_date),
      'centro': item.attributes.headquarter,
      'guia': item.attributes.guide,
      'ret': item.attributes.ret
    });
    this.showChildModal("Actualizar");
  }

  filterItems(event:any){
    console.log(event);
  }

/**
 * Muestra el modal para crear o actualizar segun corresponda.
 * @param tipo si es crear o actualizar
 */
  showChildModal(tipo:string): void {
    if(tipo === "Crear"){
      this.title = "Crear Lote";
      this.isNew = true;
    } else if(tipo === "Actualizar"){
      this.title = "Actualizar Lote";
      this.isNew = false;
    }
    this.lgModal.show();
  }

/**
 * Cierra el modal
 */
  hideChildModal(): void {
    this.lgModal.hide();
    this.cleanForm();
  }

/**
 * Cierra el mensaje de alerta.
 */
  onClosed(): void {
    this.isopen = false;
  }

  /**
  * Cierra el mensaje de alerta despues de 3 segundos
  */
  onClosedAutomatic(): void {

      setTimeout(()=>{
      this.isopen = false;
    }, 3000);

  }

/**
 * Muestra un error
 * @param  msg mensaje del error
 */
 showError(msg:string){
   if(msg == undefined){
     this.alert = 'No tiene permisos para realizar la acción.';
   }
   else{
     this.alert = msg;
   }
   this._loaddata.loadChange(100);
   this.isopen =true;
 }

/**
 * Limpia el formulario para volver a utilizarlo despues.
 */
  cleanForm():void{
    this.signupForm.reset();
    this.signupForm = new FormGroup({
      'id': new FormControl("-1",Validators.required),
      'especie': new FormControl("1",Validators.required),
      'proveedor': new FormControl("1",Validators.required),
      'codigo': new FormControl(null, Validators.required),
      'fechaextracion': new FormControl(null,),
      'fecharecepcion': new FormControl(null,),
      'fechaproceso': new FormControl(null,),
      'horaextracion': new FormControl(null,),
      'horarecepcion': new FormControl(null,),
      'horaproceso': new FormControl(null,),
      'centro': new FormControl(''),
      'guia': new FormControl(''),
      'ret': new FormControl('')
    });
  }

  changeLinks(conditions:string){
    if(this.links.first != null){
      this.links.first = this.links.first+''+conditions;
    }
    if(this.links.last != null){
      this.links.last = this.links.last+''+conditions;
    }
    if(this.links.next != null){
      this.links.next = this.links.next+''+conditions;
    }
    if(this.links.prev != null){
      this.links.prev = this.links.prev+''+conditions;
    }
  }

/**
 * Actualiza el listado por la paginacion
 * @param data nuevo listado o mensaje de error.
 */
  updateData(data:any):void{
    if(data === "Error al cargar listado."){
      this.showError(data);
    }
    else{
      this.data_list = data;
    }
  }

  showDeleteModal(lote,template: TemplateRef<any>){
      this.lote_eliminar = this.data_list[lote.index];
      this.modalRef = this.modalService.show(template);
      //console.log("Producto a Eliminar: ", this.lote_eliminar);
  }

  cerrarModalEliminar(){
    this.lote_eliminar = null;
    this.modalRef.hide();
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/lotes/lotes.component.ts